import { Types } from '@store/types';

import ApiClient from '@lib/apiClient';

export const storeUserList = (data) => {
	return {
		type: Types.STORE_USER_LIST,
		payload: data
	};
};

export const fetchUserList =
	(searchValue = '') =>
	async (dispatch) => {
		await ApiClient.GET('userSearch', `?page=0&size=15&search=${searchValue}`).then((response) => {
			dispatch(storeUserList(response.data.data));
		});
	};

export const fetchAllUserList =
	(searchValue = '', isNitexUser = false) =>
	async (dispatch) => {
		await ApiClient.GET(
			'userSearch',
			`?page=0&size=15&search=${searchValue}&isNitexUser=${isNitexUser}`
		).then((response) => {
			dispatch(storeUserList(response.data.data));
		});
	};
